import { createApiService, API_CONFIGS } from '../utils/apiService';
import axios from "@configs/axios";

const operations = {
  fetchUserFinancialCard: createApiService(
    () => axios.get("/financial/list"),
    { ...API_CONFIGS.GET_WITH_DATA, context: 'Financial - Fetch Cards' }
  ),

  addNewCard: createApiService(
    (title = "", cardNumber, accountNumber, shebaNumber) => {
      const data = {
        title,
        cart_number: cardNumber.split(" ").join(""),
        account_number: accountNumber.split(" ").join(""),
        sheba_number: shebaNumber.split(" ").join(""),
      };
      return axios.post("/financial/create", data);
    },
    { ...API_CONFIGS.POST_CREATE, context: 'Financial - Add Card' }
  ),
  removeCard: createApiService(
    (cardId) => axios.delete(`/financial/${cardId}`),
    { ...API_CONFIGS.DELETE, context: 'Financial - Remove Card' }
  ),

  editCart: createApiService(
    (cartId, cartNumber, accountNumber, shebaNumber, title) => {
      const data = {
        id: cartId,
        cart_number: cartNumber,
        account_number: accountNumber,
        sheba_number: shebaNumber,
        title,
      };
      return axios.post(`/financial`, data);
    },
    { ...API_CONFIGS.POST_ACTION, context: 'Financial - Edit Card' }
  ),
  handyDeposit: createApiService(
    (amount, tracking_id, reference_id, date, depositor_name, account_id, trans_id) => {
      const data = { amount, tracking_id, reference_id, date, depositor_name, account_id, trans_id };
      return axios.post(`/tomanWallet/offline_deposit`, data);
    },
    { ...API_CONFIGS.POST_CREATE, context: 'Financial - Handy Deposit' }
  ),

  cancelHarvest: createApiService(
    (orderId) => axios.get(`/user_wallets/toman_withdraw/cancel?id=${orderId}`),
    { ...API_CONFIGS.GET_OPTIONAL_DATA, context: 'Financial - Cancel Harvest' }
  ),
  cancelBtzConvert: createApiService(
    (orderId) => axios.get(`/btz/cancel_btz_convert?id=${orderId}`),
    { ...API_CONFIGS.GET_OPTIONAL_DATA, context: 'Financial - Cancel BTZ Convert' }
  ),

  getCoinsFee: createApiService(
    (symbol) => axios.get(`/coin/get_fee?symbol=${symbol}`),
    {
      ...API_CONFIGS.GET_WITH_DATA,
      context: 'Financial - Get Coin Fee',
      transformResponse: (data) => data.data
    }
  ),

  getAllCoinsFees: createApiService(
    () => axios.get(`/coin/get_fee`),
    {
      ...API_CONFIGS.GET_WITH_DATA,
      context: 'Financial - Get All Coins Fees',
      transformResponse: (data) => data.data
    }
  ),
};

export default operations;
